import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import Linkify from 'react-linkify';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';
import ExternalLink from './ExternalLink';

export default function LinkifyText({
  children,
  gaEventLabelPrefix,
  isExternal,
  ...rest
}: TextProps & {
  gaEventLabelPrefix?: string;
  isExternal?: boolean;
}) {
  return (
    <Linkify
      componentDecorator={(href, text, key) => {
        if (!text.startsWith('http://') && !text.startsWith('https://')) {
          return <React.Fragment key={key}>{text}</React.Fragment>;
        }
        return (
          <ExternalLink
            href={href}
            key={key}
            isExternal={isExternal}
            onClick={() => {
              if (gaEventLabelPrefix) {
                sendAnalyticsEvent(
                  'link_to',
                  'from_linkify_text',
                  `${gaEventLabelPrefix}_${href}`,
                );
              }
            }}
          >
            {text}
          </ExternalLink>
        );
      }}
    >
      <Text {...rest}>{children}</Text>
    </Linkify>
  );
}
